"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const react_1 = __importDefault(require("react"));
const BottomBarMenuItem_1 = __importDefault(require("./BottomBarMenuItem"));
const themes_1 = require("../../../themes");
const BottomBar = ({ menuElements, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(Toolbar_1.default, { sx: {
            '&.custom-toolbar': {
                padding: 0,
                alignItems: 'stretch',
                minHeight: 40,
            },
            '& button, a': {
                paddingY: 0,
                paddingX: themes_1.Spacings.small2,
            },
            '& button:hover, a:hover': {
                backgroundColor: 'grey.300',
                borderRadius: '0px',
                paddingY: 0,
                paddingX: themes_1.Spacings.small2,
            },
            '& button:active, a:active': {
                backgroundColor: 'grey.400',
            },
        }, classes: {
            root: 'custom-toolbar',
        } }, menuElements.map((menuElem, i) => (react_1.default.createElement(BottomBarMenuItem_1.default, { key: menuElem.label, label: menuElem.label, url: menuElem.url, icon: menuElem.icon, subLinks: menuElem.subLinks, externalUrl: menuElem.externalUrl, index: i })))),
    react_1.default.createElement(Divider_1.default, { sx: {
            position: 'absolute',
            width: '100%',
            left: 0,
            borderColor: 'grey.400',
        } })));
exports.default = BottomBar;
